import ThisModule from "./SingleSessionPricesTable";

export default ThisModule;
